/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  Box,
  ListItemText,
  Collapse,
  List,
  ListItemButton,
  Popover
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRight from "@mui/icons-material/ChevronRight";

import logo from '../assets/images/s10-logo.png';
import { AppBarMenus, NavItem } from "../constants/menu-items";
import { AuthData, ManualItem } from "../types";
import { useNavigate } from "react-router-dom";

interface MyAppBarProps {
  manualItems: ManualItem[];
  loginData: null | AuthData;
}

const MyAppBar = ({ manualItems, loginData }: MyAppBarProps) => {
  
  const navigate = useNavigate();
  const [mobileAnchorEl, setMobileAnchorEl] = useState<null | HTMLElement>(null);
  const [navItems, setNavItems] = useState<NavItem[]>([]);
  const [desktopMenuAnchor, setDesktopMenuAnchor] = useState<null | HTMLElement>(null);
  const [desktopSubmenuAnchor, setDesktopSubmenuAnchor] = useState<null | HTMLElement>(null);
  const [currentMenu, setCurrentMenu] = useState<string | null>(null);
  const [currentSubmenu, setCurrentSubmenu] = useState<string | null>(null);
  const isMobile = useMediaQuery("(max-width:900px)");

  useEffect(() => {
    if (manualItems.length === 0) {
      return;
    }
    setNavItems([]);
    setNavItems(organizeManualsIntoMenu());
  }, [manualItems]);

  const organizeManualsIntoMenu = (): NavItem[] => {
    const baseMenu: NavItem[] = [...AppBarMenus]
    console.log('baseMenu', baseMenu)

    manualItems.forEach(manual => {
      if (!manual.locations?.appBar) return;

      const { item: mainMenuItem, subItem } = manual.locations.appBar;
      const mainMenu = baseMenu.find(menu => menu.label === mainMenuItem);
      if (!mainMenu) return;

      if (!mainMenu.children) {
        mainMenu.children = [];
      } 
      const posibleItem = mainMenu.children.find(child => child.label === manual.name);
      const posibleSubItem = mainMenu.children.find(child => child.label === subItem);

      if (posibleItem) {
        return;
      } else if (posibleSubItem && posibleSubItem.children?.find(child => child.label === manual.name)) {
        return;
      }

      if (subItem) {
        let subMenu = mainMenu.children.find(child => child.label === subItem);
        if (!subMenu) {
          subMenu = { label: subItem, children: [],  onClick: () => navigate(`/manuals/${manual.manualId}`) };
          mainMenu.children.push(subMenu);
        }
        subMenu.children?.push({
          label: manual.name,
          href: manual.type === 'file' ? manual.fileUrl : manual.externalUrl,
          onClick: () => navigate(`/manuals/${manual.manualId}`)
        });
      } else {
        mainMenu.children.push({
          label: manual.name,
          href: manual.type === 'file' ? manual.fileUrl : manual.externalUrl,
          onClick: () => navigate(`/manuals/${manual.manualId}`)
        });
      }
    });

    return baseMenu;
  };

  const authItems: NavItem[] = [
    { 
      label: "salir", 
      href: "#login", 
      onClick: async () => {
        await localStorage.clear();
        navigate('/')
        window.location.reload();
      }
    },
  ];

  const handleDesktopMenuOpen = (event: React.MouseEvent<HTMLElement>, label: string) => {
    setDesktopMenuAnchor(event.currentTarget);
    setCurrentMenu(currentMenu === label ? null : label);
    setCurrentSubmenu(null);
  };

  const handleDesktopMenuClose = () => {
    setDesktopMenuAnchor(null);
    setCurrentMenu(null);
  };

  const handleDesktopSubmenuOpen = (event: React.MouseEvent<HTMLElement>, label: string) => {
    event.stopPropagation();
    setDesktopSubmenuAnchor(event.currentTarget);
    setCurrentSubmenu(label);
  };

  const handleDesktopSubmenuClose = () => {
    setDesktopSubmenuAnchor(null);
    setCurrentSubmenu(null);
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileAnchorEl(null);
    setCurrentMenu(null);
    setCurrentSubmenu(null);
  };

  const renderDesktopMenu = () => {
    return (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {navItems.concat(authItems).map((item) => (
          <Box key={item.label} sx={{ position: 'relative' }}>
            <Button
              color="inherit"
              onMouseEnter={(e) => item.children && handleDesktopMenuOpen(e, item.label)}
              onClick={(e) => {
                if (item.onClick && !item.children) {
                  item.onClick();
                  handleDesktopMenuClose();
                }
              }}
              sx={{ 
                minWidth: 'auto',
                '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
                cursor: item.children ? 'default' : 'pointer'
              }}
            >
              {item.label}
              {item.children && <ExpandMore sx={{ ml: 0.5 }} />}
            </Button>
  
            {item.children && (
              <Popover
                open={currentMenu === item.label}
                anchorEl={desktopMenuAnchor}
                onClose={handleDesktopMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{
                  '& .MuiPopover-paper': {
                    minWidth: 200,
                    mt: 1,
                    boxShadow: 3,
                  }
                }}
              >
                {item.children.map((child) => (
                  <MenuItem
                    key={child.label}
                    onMouseEnter={(e) => child.children && handleDesktopSubmenuOpen(e, child.label)}
                    onClick={() => {
                      if (child.onClick && !child.children) {
                        child.onClick();
                        handleDesktopMenuClose();
                      }
                    }}
                    sx={{
                      justifyContent: 'space-between',
                      '&:hover': { backgroundColor: 'action.hover' },
                      cursor: child.children ? 'default' : 'pointer'
                    }}
                  >
                    {child.label}
                    {child.children && <ChevronRight fontSize="small" />}
                  </MenuItem>
                ))}
              </Popover>
            )}
          </Box>
        ))}
      </Box>
    );
  };

  const renderDesktopSubmenu = () => {
    if (!currentMenu || !desktopSubmenuAnchor) return null;
  
    const parentMenu = navItems.find(item => item.label === currentMenu);
    if (!parentMenu?.children) return null;
  
    const submenuItem = parentMenu.children.find(item => item.label === currentSubmenu);
    if (!submenuItem?.children) return null;
  
    return (
      <Popover
        open={Boolean(currentSubmenu)}
        anchorEl={desktopSubmenuAnchor}
        onClose={handleDesktopSubmenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        sx={{
          '& .MuiPopover-paper': {
            minWidth: 200,
            boxShadow: 3,
            borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
            borderRadius: '0 4px 4px 4px',
            marginLeft: '0px !important',
            marginTop: '-8px !important',
          }
        }}
        disableAutoFocus
        disableEnforceFocus
      >
        <Box onMouseLeave={handleDesktopSubmenuClose}>
          {submenuItem.children.map((item) => (
            <MenuItem
              key={item.label}
              onClick={(e) => {
                e.stopPropagation();
                if (item.onClick) {
                  item.onClick();
                  handleDesktopMenuClose();
                  handleDesktopSubmenuClose();
                }
              }}
              sx={{ 
                '&:hover': { backgroundColor: 'action.hover' },
                cursor: 'pointer'
              }}
            >
              {item.label}
            </MenuItem>
          ))}
        </Box>
      </Popover>
    );
  };

  const renderMobileMenu = () => {
    const allItems = [...navItems, ...authItems];
  
    return (
      <Menu
        anchorEl={mobileAnchorEl}
        open={Boolean(mobileAnchorEl)}
        onClose={handleMobileMenuClose}
        PaperProps={{
          style: {
            maxHeight: '80vh',
            width: '60vw',
          }
        }}
      >
        {allItems.map((item) => {
          const hasChildren = item.children && item.children.length > 0;
  
          return (
            <React.Fragment key={item.label}>
              <ListItemButton
                onClick={() => {
                  if (hasChildren) {
                    setCurrentMenu(currentMenu === item.label ? null : item.label);
                  } else if (item.onClick) {
                    item.onClick();
                    handleMobileMenuClose();
                  }
                }}
                sx={{ 
                  pl: 2,
                  cursor: hasChildren ? 'default' : 'pointer'
                }}
              >
                <ListItemText primary={item.label} />
                {hasChildren && (currentMenu === item.label ? <ExpandLess /> : <ExpandMore />)}
              </ListItemButton>
  
              {hasChildren && (
                <Collapse in={currentMenu === item.label} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.children?.map((child) => {
                      const childHasChildren = child.children && child.children.length > 0;
  
                      return (
                        <React.Fragment key={child.label}>
                          <ListItemButton
                            onClick={() => {
                              if (childHasChildren) {
                                setCurrentSubmenu(currentSubmenu === child.label ? null : child.label);
                              } else if (child.onClick) {
                                child.onClick();
                                handleMobileMenuClose();
                              }
                            }}
                            sx={{ 
                              pl: 4,
                              cursor: childHasChildren ? 'default' : 'pointer'
                            }}
                          >
                            <ListItemText primary={child.label} />
                            {childHasChildren && (currentSubmenu === child.label ? <ExpandLess /> : <ExpandMore />)}
                          </ListItemButton>
  
                          {childHasChildren && (
                            <Collapse in={currentSubmenu === child.label} timeout="auto" unmountOnExit>
                              <List component="div" disablePadding>
                                {child.children?.map((subChild) => (
                                  <MenuItem
                                    key={subChild.label}
                                    onClick={() => {
                                      if (subChild.onClick) {
                                        subChild.onClick();
                                        handleMobileMenuClose();
                                      }
                                    }}
                                    sx={{ 
                                      pl: 6,
                                      cursor: 'pointer'
                                    }}
                                  >
                                    {subChild.label}
                                  </MenuItem>
                                ))}
                              </List>
                            </Collapse>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          );
        })}
      </Menu>
    );
  };

  return (
    <AppBar position="static" sx={{ width: '100%', zIndex: 1200 }}>
      <Toolbar>
        <Box 
          component="img"
          src={logo}
          alt="Logo"
          sx={{ 
            height: 40,
            mr: 2,
          }}
          onClick={() => {
            navigate('/')
          }}
        />

        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} />

        {!isMobile ? (
          <>
            {renderDesktopMenu()}
            {renderDesktopSubmenu()}
          </>
        ) : (
          <>
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              onClick={handleMobileMenuOpen}
            >
              <MenuIcon />
            </IconButton>
            {renderMobileMenu()}
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default MyAppBar;